<template>
  <div id="hel" class="content">
    <div class="animated fadeIn">
      <div class="orders">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <strong class="card-title">Solicitud de Crédito</strong>
              </div>
              <div id="pos" class="card-body">
                <div class="hoja">
                  <table style="width:100%">
                    <tbody>
                    <tr class="">
                      <td width="20%">
                        <img v-if="displayButton" src="@/assets/images/SOLICITUD PERSONA FISICA.jpg" alt="">
                      </td>
                      <td width="60%" class="pl-2 pr-2">
                        <h3 class="text-center font-weight-bold">SOLICITUD DE CRÉDITO PERSONA FÍSICA</h3>
                        <h4 class="text-center">Y FORMATO DE ENTREVISTA PERSONAL E IDENTIFICACIÓN DEL CLIENTE</h4>
                      </td>
                      <td width="20%" class="text-right" style="font-size: 11px;">
                        <strong>GM Financia! de México S.A.
                          de C.V. SOFOM E.R.</strong> <br>
                        Ave. Eugenio Garza Lagüera Nº933, <br>
                        Planta Baja, Colonia Valle Oriente <br>
                        San Pedro Garza García, <br>
                        Nuevo León, C.P. 66269
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">1 DATOS GENERALES</div>
                  <table style="width:100%">
                    <tbody>
                    <tr class="">
                      <td width="20%">
                        <span class="d-block">NOMBRES(s) (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">APELLIDO PATERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">APELLIDO MATERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="40%">
                        <h5> SOLTERO O CASADO CON BIENES SEPARADOS</h5>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="10%">
                        <span class="d-block">FECHA DE NACIMIENTO </span>
                        <input type="date" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">PAIS DE NACIMIENTO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">ENTIDAD FEDERATIVA DE NACIMIENTO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">RFC (Con homoclave)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="50%">
                        <div class="row">
                          <div class="col-6">
                            <span class="d-block for-checkboxes">POR FAVOR INDIQUE SI USTED ES (Régimen)</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PERSONA FÍSICA</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <span class="d-block for-checkboxes">SEXO</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">MASCULINO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">FEMENINO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="15%">
                        <span class="d-block">NACIONALIDAD</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">EN CASO DE SER EXTRANJERO: SEÑALE SU No. DE ID FISCAL Y/O RFC DE SU PAÍS DE ORIGEN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">CORREO ELECTRÓNICA (email)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="50%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">ESTADO CIVIL:</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SOLTERO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">DIVORCIADO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CASADO (Separacion de Bienes)</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">VIUDO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="10%">
                        <span class="d-block">No. DE DEPENDIENTES</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CURP (En caso de tenerlo)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">No. DE SERIE DE LA FIRMA ELECTRÓNICA AVANZADA (En caso de tenerla)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">2. DATOS DEL CÓNYUGUE</div>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="15%">
                        <span class="d-block">NOMBRES(s) (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">APELLIDO PATERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">APELLIDO MATERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">FECHA DE NACIMIENTO </span>
                        <input type="date" name="name" class="w-100 input-config" />
                      </td>
                      <td width="40%">
                        <span class="d-block">RFC (Con homoclave)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="40%">
                        <div class="row">
                          <div class="col-6">
                            <span class="d-block for-checkboxes">POR FAVOR INDIQUE SI USTED ES (Régimen):</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PERSONA FÍSICA</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <span class="d-block for-checkboxes">SEXO:</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">MÁSCULINO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">FEMENINO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="15%">
                        <span class="d-block">PAIS DE NACIMIENTO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">ENTIDAD FEDERATIVA DE NACIMIENTO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">NACIONALIDAD</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CORREO ELECTRÓNICO (email)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">3. DOMICILIO ACTUAL</div>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="40%">
                        <span class="d-block">DIRECCIÓN: Calle, Exterior, Interior</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">COLONIA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">MUNICIPIO O DELEGACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CIUDAD O POBLACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">ESTADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="10%">
                        <span class="d-block">PAIS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">CP</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">TIPO DE RESIDENCIA:</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PROPIA (A su nombre)</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">RENTADA</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">HIPOTECADA</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">NO APLICA</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <span class="d-block">ANTIGUEDAD AÑOS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">ANTIGUEDAD MESES</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">PAGO MENSUAL, RENTA O HIPOTECA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">TELÉFONO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CELULAR</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">4. OCUPACIÓN O PROFESION (Empleo actual)</div>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="30%">
                        <span class="d-block">PROFESIÓN O TÍTULO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">DENOMINACIÓN DE LA EMPRESA O NEGOCIO (Nombre)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">ORIGEN DE LOS RECURSOS:</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">AMA DE CASA</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">PENSIONADO O JUBILADO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">ASALARIADO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">INDEPENDIENTE</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">ACTIVIDAD O GIRO DE LA EMPRESA:</span>
                            <div class="checkboxes-container">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">AGRO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">ALIMENTOS Y BEBIDAS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">ALQUILER</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">ARRIENDO DE VEHÍCULOS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">AUTOMOTRIZ</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">BENEFICIENCIA/ORGANIZACIÓN SIN FINES DE LUCRO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CAMBIO DE DIVISAS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CARGA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CASINO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">COMERCIALIZACIÓN DE METALES Y PIEDRAS PRECIOSAS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">COMERCIALIZACIÓN DE OBRAS DE ARTE</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">COMERCIO AL POR MAYOR</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">COMERCIO AL POR MENOR</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">COMERCIO EXTERIOR</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CONSTRUCCIÓN</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CORPORATIVOS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">EDUCACIÓN, INSTRUCCIÓN Y CAPACITACIÓN</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">ENTRETENIMIENTO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">EXPLOTACIÓN DE RECURSOS NATURALES</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">FARMACIA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">FINANCIERO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">GOBIERNO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">INDUSTRIA MANUFACTURERA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">INMOBILIARIO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">JUEGOS DE AZAR</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">MANEJO DE RESIDUOS Y DESECHOS</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">MAQUILADORA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">MENSAJERÍA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">OFICIOS Y SERVICIOS VARIOS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PESCA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PUBLICIDAD Y MEDIOS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">RELIGIÓN</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SEGURIDAD</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIO DE BLINDAJE</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIO DE FE PUBLICA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIO PUBLICO DE AGUA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIO PUBLICO DE ELECTRICIDAD</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIO PUBLICO DE GAS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIO MÉDICOS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIO PROFESIONALES, CIENTÍFICOS Y TÉCNICOS</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SINDICATO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">TELEFONÍA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">TRANSPORTE</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">TRASLADO O CUSTODIA DE VALORES</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">TURISMO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <hr>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">OCUPACIÓN:</span>
                            <div class="checkboxes-container">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">AGENTE ADUANAL</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">AGENTE DE BIENES RAÍCES</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CARGO EJECUTIVO / GERENTE</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CONDUCTOR / TRANSPORTADOR</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">CONSTRUCCIÓN</label>
                              </div>

                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">DESEMPLEADO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">ESTUDIANTE</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">HOGAR</label>
                              </div>

                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">JORNALERO / MINERO / AGRICULTOR / ALBAÑIL</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">JOYERO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">JUBILADO / PENSIONADO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">MILITAR</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">NOTORIO / CORREDOR PÚBLICO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">OBRERO / OPERARIO</label>
                              </div>

                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">OFICINISTA</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">OFICIOS VARIOS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PROFESIONAL / INGENIERO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PROFESOR / MÉDICO / PROF. SALUD</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">PROPIETARIO DE NEGOCIO / INDEPENDIENTE</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SACERDOTE</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SEGURIDAD / GUARDIA (CIVIL O PRIVADO)</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SERVICIOS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">SUPERVISOR / ADMINISTRADOR</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <div class="checkboxes-container mt-0">
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">TÉCNICO</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">VENTAS</label>
                              </div>
                              <div class="form-check pt-1">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">OTROS</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="10%">
                        <span class="d-block">TELÉFONO (Empleo)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="5%">
                        <span class="d-block">EXT</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">INGRESOS MENSUALES (Netos comprobantes)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">ANTIGUEDAD AÑOS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">ANTIGUEDAD MESES</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">NOMBRE DEL JEFE</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">TIPO:</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">TEMPORAL DE MEDIOTIEMPO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">PERMANENTE DE MEDIO TIEMPO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">TEMPORAL DE TIEMPO COMPLETO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">PERMANENTE DE TIEMPO COMPLETO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="30%">
                        <span class="d-block">DIRECCIÓN: Calle, Exterior, Interior</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">COLONIA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">MUNICIPIO O DELEGACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CIUDAD O POBLACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">ESTADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="20%">
                        <span class="d-block">PAIS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CP</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">INGRESO ADICIONALES (Comprobantes)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">DESCRIPCIÓN INGRESOS ADICIONALES</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">5. OCUPACIÓN O PROFESIÓN CÓNYUGUE (Empleo Actual)</div>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="100%">
                        <span class="d-block">PROFESIÓN O TÍTULO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Para salto de página -->
                  <h6 class="for-break-line"></h6>
                  <div class="separator-tag">6. EMPLEO ANTERIOR DEL SOLICITANTE (Llenar sólo en caso de que el solicitante tenga una antiguedad menor a 1 año en empleo actual)</div>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="100%">
                        <span class="d-block">EMPRESA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">7. REFERENCIAS PERSONALES</div>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="50%">
                        <span class="d-block for-checkboxes">REFRENCIA 1: <span class="for-checkboxes-description">NOMBRES Y APELLIDOS</span></span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="50%">
                        <span class="d-block">DIRECCCIÓN: Calle, Exterior, Interior</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="20%">
                        <span class="d-block">COLONIA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">MUNICIPIO O DELEGACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">CIUDAD O POBLACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">ESTADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">TELÉFONO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="30%">
                        <span class="d-block for-checkboxes">REFRENCIA 2: <span class="for-checkboxes-description">NOMBRES Y APELLIDOS</span></span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">TELÉFONO:</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block for-checkboxes">REFRENCIA 3: <span class="for-checkboxes-description">NOMBRES Y APELLIDOS</span></span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">TELÉFONO:</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">8. ENTREVISTA PERSONAL</div>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="30%">
                        1.- ¿Cuál será el destino que le dará al vehículo sisu crédito es autorizado?
                      </td>
                      <td width="70%">
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">USO PARTICULAR</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">ARRENDAMIENTO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">TAXI</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">TRABAJO / NEGOCIO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">RENTA DIARIA</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">TERCERA PERSONA</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="100%">
                        2.- Mencione si el vehículo será utilizado principalmente por otra empresa o una tercera persona (diferente al solicitante y/o co-solicitante) (Propietario Real).
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                        En caso afirmativo, favor de proporcionar la siguiente información:
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="25%">
                        <span class="d-block for-checkboxes">DATOS DEL PROPIETARIO REAL <span class="for-checkboxes-description">NOMBRE(S) COMPLETO(S) (Sin abreviaciones)</span></span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">APELLIDO PARTERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">APELLIDO MATERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">GÉNERO:</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">MASCULINO</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">FEMENINO</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="10%">
                        <span class="d-block">FECHA DE NACIMIENTO</span>
                        <input type="date" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">PAÍS DE NACIMIENTO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="">
                    <tbody>
                    <tr>
                      <td width="12%">
                        <span class="d-block">NACIONALIDAD</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="12%">
                        <span class="d-block">OCUPACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="12%">
                        <span class="d-block">PROFESIÓN O TÍTULO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">ACTIVIDAD O GIRO DEL NEGOCIO AL QUE SE DEDICA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">ENTIDAD FEDERATIVA DE NACIMIENTO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">NÚM DE TEL. DONDE SE PUEDA LOCALIZAR</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="">
                    <tbody>
                    <tr>
                      <td width="30%">
                        <span class="d-block">CORREO ELECTRÓNICO (e-mail)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">CURP (en caso de contar con este)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">RFC con Homoclave (en caso de contar con este)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">No. DE SERIE DE LA FIRMA ELECTRÓNICA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="40%">
                        <span class="d-block for-checkboxes">DOMICILIO PARTICULAR <span class="for-checkboxes-description">DIRECCIÓN: Calle, Número Exterior e Interior</span></span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">COLONIA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">MUNICIPIO O DELEGACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CIUDAD O POBLACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">ESTADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="">
                    <tbody>
                    <tr>

                      <td width="15%">
                        <span class="d-block">PAÍS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CP</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="100%">
                        3.- Señale si el crédito será liquidado con recursos lícitos propios (Proveedor de Recursos)
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                        En caso negativo, favor de proporcionar la siguiente información:
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>

                      <td width="15%">
                        <span class="d-block">PAÍS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CP</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="15%">
                        <div class="row">
                          <div class="col-12">
                            <span class="d-block for-checkboxes">DATOS DEL PROVEEDOR DE RECURSOS:</span>
                            <div class="checkboxes-container">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                <label class="form-check-label" for="inlineCheckbox1">RÉGIMEN PERSONA FÍSICA</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                                <label class="form-check-label" for="inlineCheckbox2">RÉGIMEN PERSONA MORAL</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td width="20%">
                        <span class="d-block">NOMBRE COMPLETO O RAZÓN SOCIAL (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">NACIONALIDAD</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">CURP (Cuando cuente con ella)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="15%">
                        <span class="d-block">RFC con Homoclave</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="30%">
                        <span class="d-block">NUMERO DE SERIE DE LA FIRMA ELECTRÓNICA AVANZADA (Cuando cuente con ella)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">EN CASO DE SER EXTRANJERO SEÑALE SU NÚMERO DE IDENTIFICACIÓN FISCAL</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">EN CASO DE PERSONA FÍSICA SEÑALE SU FECHA DE NACIMIENTO</span>
                        <input type="date" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="15%">
                        <span class="d-block">DIRECCIÓN: Calle, Número Exterior e Interior</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">COLONIA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">MUNICIPIO O DELEGACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">CIUDAD O POBLACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">ESTADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="50%">
                        <span class="d-block">PAÍS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="50%">
                        <span class="d-block">CP</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="90%">
                        4. ¿Usted desempeña o ha desempeñado funciones públicas o actividades políticas DESTACADAS en territorio nacional o en el extranjero, entendiéndose de forma enunciativa más no limitativa las funciones o actividades de: Presidente de la República,
                        Gobernador de Estado, Jefe de Gobierno del D.F., Diputado, Senador, Presidente Municipal, Secretario de Ayuntamiento, Síndico, Regidor, Ministro de la Suprema Corte de Justicia de la Nación, Magistrado, Juez, Consejero de la Judicatura, Secretario de
                        Estado, Procurador de Justicia, Secretario Ejecutivo del Instituto Nacional Electoral, Consejero Electoral, Jefe de algún departamento de la Administración Pública, Tesorero de la Administración Pública, Director General de algún Organismo Descentralizado o
                        de Empresa de Participación Estatal Mayoritaria o Fideicomiso Público, Líder Político, Militar de Alto Rango, Cónsul, Embajador?
                      </td>
                      <td width="10%">
                        <div class="checkboxes-container mt-0">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check pt-2">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="100%">
                        <span class="d-block">DETALLE CARGO Y FECHA DESDE LA QUE LO DESEMPEÑA O LO DEJÓ DE DESEMPEÑAR</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="50%">
                        5. ¿Tiene usted algún familiar por consaguinidad o afinidad hasta segundo grado: Hijo(a), padre, madre, abuelo(a), nieto(a), hermano(a),
                        cónyuge, hijos de cónyuge, suegro(a), cuñado(a), abuelo(a) de cónyuge, concubina, concubinario, tío, primos hermanos; yerno o nuera,
                        que desempeñe o haya desempeñado en el último año, funciones públicas o actividades políticas DESTACADAS en territorio nacional o
                        en el extranjero, entendiéndose de forma enunciativa más no limitativa, las funciones o actividades enlistadas en la pregunta anterior?
                      </td>
                      <td width="10%">
                        <div class="checkboxes-container mt-0">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check pt-2">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                      </td>
                      <td width="40%"></td>
                    </tr>
                    </tbody>
                  </table>

                  <!-- Para salto de página -->
                  <h6 class="for-break-line"></h6>

                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="100%">
                        <span class="d-block">DETALLE CARGO Y FECHA DESDE LA QUE LO DESEMPEÑA O LO DEJÓ DE DESEMPEÑAR</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="100%">
                        <span class="d-block">NOMBRE Y APELLIDOS COMPLETOS DEL FAMILIAR (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">9. REFERENCIAS DE CRÉDITO</div>
                  <table style="width:100%">
                    <tbody>
                    <tr>
                      <td width="25%">
                        1.- ¿Es titular de alguna tarjeta de crédito?
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                      </td>
                      <td width="25%">
                        <span class="d-block">INDIQUE LOS ÚLTIMOS 4 DÍGITOS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%">
                        2.- ¿Tiene un crédito hipotecario bancario vigente?
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                      </td>
                      <td width="25%">
                        3.- ¿Ha aperturado un crédito automotriz bancario en los últimos dos años?
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">10. PERSONA DESIGNADA PARA RECIBIR LA FACTURA EN CASO DE FALLECIMIENTO DEL CLIENTE (Debe ser mayor de 18 años)</div>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="20%">
                        <span class="d-block">NOMBRE(S) (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">APELLIDO PATERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="20%">
                        <span class="d-block">APELLIDO MATERNO (Sin abreviaciones)</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">FECHA DE NACIMIENTO</span>
                        <input type="date" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">LUGAR DE NACIMIENTO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="25%">
                        <span class="d-block">DIRECCIÓN: Calle interior, exterior</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%">
                        <span class="d-block">COLONIA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%">
                        <span class="d-block">MUNICIPIO O DELEGACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%">
                        <span class="d-block">CIUDAD O POBLACIÓN</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="25%">
                        <span class="d-block">ESTADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%">
                        <span class="d-block">PAÍS</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="10%">
                        <span class="d-block">CP</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="40%">

                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">AUTORIZACIÓN PARA INVESTIGACIÓN CREDITICIA DEL</div>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="100%">
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">ACREDITADO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">COACREDITADO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">AVAL</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="100%">
                        Por medio de la presente AUTORIZO expresamente a <strong>GM FINANCIAL DE MÉXICO S.A. DE C.V. SOFOM LR. ('"GM FINANCIAL "')</strong>, para que por coNducto de sus funcionarios facultados. lleve a cabo las investigaciooes sobre mi comportamiento crediticio en las Sociedades de Información
                        Crediticia que GM FINANCIAL estime convenientes
                        <br>
                        Asimismo declaro que tengo pleno conocimiento de la naturaleza y alcance de; (1) las Sociedades de Información Crediticia; (11) de la información contenida en los reportes de crédito y reporte de crédito especial; (111) la información que la Sociedad de Información Crediticia proporcione
                        a GM FINANCIAL; (IV) el uso que GM FINANCIAL hará de tal información; y (V) que GM FINANCIAL podrá realizar consultas periódicas a mi historial crediticio, consintiendo que esta autorización se encuentre vigente por un periodo de tres años contados a partir de la techa de su expedición
                        y en todo caso durante el tiempo que se mantenga la relación jurídica entre el suscrito y GM FINANCLAL
                        <br>
                        Estoy consciente y acepto que este documento quede bajo custodia de GM FINANCIAL y/o de la Sociedad de Información Crediticia consultada, para efectos de control y cumplimiento del artículo 28 de la Ley para Regular las Sociedades de Información Crediticia; mismo que señala
                        que las Sociedades de Información Crediticia sólo podrán proporciooar información a un Usuario (como es el caso de GM FINANCIAL), cuando éste cuente con autorización expresa del Cliente mediante su firma autógrafa.
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="20%">
                        <span class="d-block">LUGAR Y FECHA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="40%">
                        <span class="d-block">NOMBRE COMPLETO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="40%" class="v3">
                        <p class="d-block text-leftñ description">FIRMA</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag mt-4">NOTAS, AUTORIZACIONES Y AVISO DE PRIVACIDAD</div>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="100%">
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">ACREDITADO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">COACREDITADO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">AVAL</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="">
                    <tbody>
                    <tr>
                      <td width="50%">
                        <span class="d-block for-checkboxes">A) NOTAS Y AUTORIZACIONES: </span>
                        <br>
                        Manifiesto (manifestamos) bajo protesta de decir verdad que: (I) Esta Solicitud de crédito, Persona física y Formato de Entrevista
                        Personal e Identificación del Cliente (“Solicitud”) será sometida a GM FINANCIAL DE MÉXICO S.A. DE C.V. SOFOM E.R.
                        (“GM FINANCIAL”) para la posibilidad del otorgamiento del financiamiento respectivo, sujeto a la
                        investigación y autorización de crédito correspondiente y a la entrega de la documentación requerida. (II) Estoy (estamos) de
                        acuerdo en contratar una póliza de seguro contra daños con cobertura amplia, mientras permanezca vigente en los términos
                        del contrato de crédito respectivo el financiamiento que en su caso se me (nos) llegue a otorgar. (III) Certifico
                        (certificamos) que la información proporcionada en esta Solicitud es correcta, completa y refleja con exactitud mi (nuestra) situación
                        financiera. Así mismo manifiesto (manifestamos) bajo protesta de decir verdad contar con el consentimiento de las personas
                        citadas como referencias, para ser contactadas por GM FINANCIAL para corroborar esta información y cualquier asunto
                        relacionado con el otorgamiento del financiamiento. (IV) Estoy (estamos) de acuerdo en que el presente documento sirva
                        como constancia del resultado de la entrevista personal que me (nos) ha sido realizado por GM FINANCIAL de conformidad con las
                        disposiciones de carácter general a que se refieren los artículos 115 de la Ley de Instituciones de Crédito en relación con el 87-D de la
                        Ley General de Organizaciones y Actividades Auxiliares del Crédito y 95-Bis de este último ordenamiento, aplicables a las sociedades
                        financieras de objeto múltiple. (V) En caso de que se me (nos) otorgue el financiamiento, me (nos) obligo (obligamos) a notificar
                        inmediatamente a GM FINANCIAL cualquier cambio en la información proporcionada en esta Solicitud y en su caso en el contrato de
                        crédito correspondiente.
                      </td>
                      <td width="25%">
                        <span class="d-block">LUGAR Y FECHA</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%">

                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="50%">
                        <span class="d-block for-checkboxes">B) AVISO DE PRIVACIDAD </span>
                        <br>
                        Manifiesto que previo al llenado de la presente solicitud, GM Financial de México, S.A. de C.V. SOFOM E.R. (en adelante GMF) puso a mi
                        disposición su Aviso de Privacidad para Clientes ( en adelante el Aviso de Privacidad), mismo que se encuentra disponible en las
                        instalaciones del Distribuidor General Motors, así como también en la página en internet de GMF (www.gmfinancial.mx), y a través del
                        número telefónico: (81) 83 99 63 64. Con base en lo previsto en el Aviso de Privacidad:
                      </td>
                      <td width="25%">
                        <span class="d-block">NOMBRE COMPLETO DEL ACREDITADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%" class="v3">
                        <p class="d-block text-leftñ description">FIRMA DEL ACREDITADO</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="25%">
                        Consiento el tratamiento de mis datos personales para las finalidades necesarias.
                      </td>
                      <td width="25%">
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                      </td>
                      <td width="50%"></td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="25%">
                        Consiento el tratamiento de mis datos personales para las finalidades no necesarias.
                      </td>
                      <td width="25%">
                        <div class="checkboxes-container mt-0">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">NO</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                            <label class="form-check-label" for="inlineCheckbox1">SÍ</label>
                          </div>
                        </div>
                      </td>
                      <td width="50%"></td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="50%">
                        Así mismo, GMF hace de mi conocimiento que puedo solicitar al Distribuidor General Motors una versión impresa de dicho Aviso de Privacidad.
                      </td>
                      <td width="25%">
                        <span class="d-block">NOMBRE COMPLETO DEL CO-ACREDITADO</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%" class="v3">
                        <p class="d-block text-leftñ description">FIRMA DEL CO-ACREDITADO</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-4">
                    <tbody>
                    <tr>
                      <td width="50%"></td>
                      <td width="25%">
                        <span class="d-block">NOMBRE COMPLETO DEL AVAL</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="25%" class="v3">
                        <p class="d-block text-leftñ description">FIRMA DEL AVAL</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="separator-tag">PARA USO EXCLUSIVO DEL DISTRIBUIDOR</div>

                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="100%">
                        En este acto manifiesto que: Tuve a la vista la Solicitud Original debidamente requisitada por el acreditado y los demás -nrmantes, y he cotejado los documentos originales coo las copias entregadas por todos los -nrmantes de la Solicitud.
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table style="width:100%" class="mt-2">
                    <tbody>
                    <tr>
                      <td width="30%">
                        <span class="d-block">FECHA</span>
                        <input type="date" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%">
                        <span class="d-block">NOMBRE COMPLETO DEL REPRESENTANTE DEL DISTRIBUIDOR</span>
                        <input type="text" name="name" class="w-100 input-config" />
                      </td>
                      <td width="30%" class="v3">
                        <p class="d-block text-leftñ description">FIRMA DEL REPRESENTANTE DEL DISTRIBUIDOR</p>
                      </td>
                      <button v-if="displayButton" @click="terminar" style="margin-right: 1em; margin-top: 1em; margin-bottom: 1em" class="btn bnt-md btn-primary float-right">Terminar</button>
                    </tr>
                    </tbody>
                  </table>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import jsPDF from 'jspdf'
// import { jsPDF } from "jspdf";
// import { jsPDF } from "jspdf";
export default {
  name: 'SolicitudCredito',
  data () {
    return {
      displayButton: true
    }
  },
  methods: {
    terminar () {

      var divContents = $("#pos").html();
      var printWindow = window.open('', '', 'height=400,width=800');
      printWindow.document.write('<html><head><title>Solicitud de Crédito</title>');
      printWindow.document.write('</head><body >');
      printWindow.document.write(divContents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      // console.log(printWindow.)
      printWindow.print();



      /*this.displayButton = false
      var val = htmlToPdfmake($("#pos").html());
      var dd = {content:val};
      var c = pdfMake.createPdf(dd).download();
      console.log(c)
      this.displayButton = true

      var doc = new jsPDF()

      doc.text('Hello world!', 10, 10)
      doc.save('a4.pdf')
      */

// Save the PDF
      // doc.save('sample-document.pdf');

      /*html2canvas(document.body, {
        onrendered: function (canvas) {

          var img = canvas.toDataURL("image/png");
          var doc = new jsPDF();
          doc.addImage(img, 'JPEG', -20, -20);
          doc.save('test.pdf');
        }
      })*/

      /*
      this.$http.post('/web/contact/solicitud', fd, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        console.log(res)
      })
      */

      // Choose the element and save the PDF for our user.


      // var divContents = $("#pos").html();
      // let pdfName = 'test';
      // var doc = new jsPDF();
      // doc.text(divContents, 10, 10);
      // doc.save(pdfName + '.pdf');
      // this.displayButton = false
      /*
      html2canvas(document.getElementById('pos'), {
        onrendered: function(canvas) {
          document.body.appendChild(canvas);
          var img = canvas.toDataURL("image/png");
          var doc = new jsPDF();
          doc.addImage(img, 'JPEG', 10, 10);
          doc.save('test.pdf');
          // window.open(img);
        }
      });
      */


    }
  }
}
</script>

<style>

</style>
